import { ITranslationList } from ".";

export const list: ITranslationList = new Map([
  ["Premium", "Premium"],
  ["What are you looking for?", "Vad letar du efter?"],
  ["Home page", "Hem"],
  ["Menu", "Meny"],
  ["Search", "Sök"],
  ["User menu", "Användarmeny"],
  ["Back", "Tillbaka"],
  ["Clear search", "Rensa sökningen"],
  ["Shopping List", "Inköpslista"],
  ["Cancel", "Avbryt"],
  ["Popular", "Populära"],
  ["History", "Tidigare"],
  ["Suggestions", "Förslag"],
  ["Close Menu", "Stäng menyn"],
  ["Only available in Premium Subscriptions", "Only available in Premium Subscriptions"],
  ["Header", "Header"],
  ["You have items in the Shopping List", "You have items in the Shopping List"],
  ["DD Pro", "DD Pro"],
  ["Access admin dashboard", "Access admin dashboard"],
  ["Challenges", "Utmaningar"],
  ["Trending", "Utforska proteinrik kost"],
  ["My tracking", "My tracking"],
]);
